import Alert from '@mui/material/Alert';
import React from 'react';

import { useTranslate } from '@/hooks/useTranslate';

const MaxAccountsPerTypeAlert: React.FC = () => {
  const { t } = useTranslate();
  return (
    <Alert severity="error" variant="outlined">
      {t('accountTypeCard.maxAccountsPerTypeReached')}
    </Alert>
  );
};

export default MaxAccountsPerTypeAlert;
